import React from 'react'
import { filter } from 'lodash'
import { useQuery } from "@apollo/client"

import SectionHeader from '../../components/SectionHeader'
import EcsButton from '../../components/Button'
import { generateUrl } from '../../helpers/clinic'

export default ({globalData, clinic}) => {
  return (
    <div className="min-h-64 bg-gradient-to-b from-sky-400 to-sky-700">
      <div className="max-w-6xl mx-auto px-4 py-16 min-h-64">
        <SectionHeader
          subtitle={clinic ? clinic.name : 'Eye Clinics of Seattle'}
          title={'About Us'}
          theme={'blue'}
        />
        <div className="max-w-xl ml-auto text-white text-right font-bold text-xl md:text-2xl">
          <div className="mb-8">Meet our doctors and staff!</div>
          <EcsButton label={"Learn More"} url={generateUrl(clinic, 'about')} theme="dark" />
        </div>
      </div>
    </div>
  )
}